export const PACKAGE_UNIT_PIECE = Symbol('packageUnitPiece');
export const PACKAGE_UNIT_WEIGHT = Symbol('packageUnitWeight');

export type PackageUnit = (
  | typeof PACKAGE_UNIT_PIECE
  | typeof PACKAGE_UNIT_WEIGHT
);
